import React from 'react'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import { ADMIN_ROUTES, FEATURE_FLAG, ICON_NAMES } from '../../../../constants'
import CardTile from '../CardTile'
import { useCheckPolicy } from '../../../../hooks'
import { ASSET_TAGS, TAGS, BENCHMARKS, THINGS, KDP, PERMISSIONS } from '../../../../policies/admin'
import { useFeatureFlag } from '../../../../redux/slices/appConfig'

export function useCanViewDataMaintenance () {
  const canViewAssetTags = useCheckPolicy(ASSET_TAGS.viewAssetTagTypes)
  const canViewTransactionTagging = useCheckPolicy('internalOnly')

  const canViewBenchmarks = useCheckPolicy(BENCHMARKS.viewBenchmarks)
  const { active: isBenchmarksActive } = useFeatureFlag(FEATURE_FLAG.BENCHMARKS_SETUP)

  const canViewFirmGoals = useCheckPolicy(PERMISSIONS.viewFirmGoals)

  return canViewAssetTags || canViewTransactionTagging || (canViewBenchmarks && isBenchmarksActive) || canViewFirmGoals
}

function DataMaintenance () {
  const canViewTransactionTagging = useCheckPolicy('internalOnly')

  const canViewBenchmarks = useCheckPolicy(BENCHMARKS.viewBenchmarks)
  const canViewTags = useCheckPolicy(TAGS.viewTags)
  const canViewContent = useCheckPolicy(THINGS.viewThings)
  const canViewKeyDataPoints = useCheckPolicy(KDP.viewKDP)
  const { active: isBenchmarksActive } = useFeatureFlag(FEATURE_FLAG.BENCHMARKS_SETUP)
  const canViewBrands = useCheckPolicy(PERMISSIONS.brandConfiguration)
  const { active: multiBrand } = useFeatureFlag(FEATURE_FLAG.MULTI_BRAND_FIRM)
  const canViewFirmGoals = useCheckPolicy(PERMISSIONS.viewFirmGoals)

  return (
    <Container maxWidth='xl' style={{ paddingTop: '1.5rem' }}>
      <Grid container spacing={3}>
        {canViewTransactionTagging ? (
          <Grid item xs={12} md={3}>
            <CardTile
              index={0}
              to='/admin/data-maintenance/transaction-tagging'
              icon={ICON_NAMES.transaction}
              title='Transaction Tagging'
            />
          </Grid>
        ) : null}
        {isBenchmarksActive && canViewBenchmarks ? (
          <Grid item xs={12} md={3}>
            <CardTile
              index={2}
              to={ADMIN_ROUTES.BENCHMARKS}
              icon={ICON_NAMES.benchmarks}
              title='Benchmarks'
            />
          </Grid>
        ) : null}
        {canViewTags ? (
          <Grid item xs={12} md={3}>
            <CardTile
              index={1}
              to='/admin/data-maintenance/tags'
              icon={ICON_NAMES.tag}
              title='Tags'
            />
          </Grid>
        ) : null}
        {canViewContent ? (
          <Grid item xs={12} md={3}>
            <CardTile
              index={3}
              to='/admin/data-maintenance/content/thing-configuration'
              icon={ICON_NAMES.book}
              title='Content'
            />
          </Grid>
        ) : null}
        {canViewKeyDataPoints ? (
          <Grid item xs={12} md={3}>
            <CardTile
              index={4}
              to='/admin/data-maintenance/key-data-points'
              icon={ICON_NAMES.database}
              title='Key Data Points'
            />
          </Grid>
        ) : null}
        {multiBrand && canViewBrands ? (
          <Grid item xs={12} md={3}>
            <CardTile
              index={4}
              to='/admin/data-maintenance/brands'
              icon={ICON_NAMES.persons}
              title='Brands'
            />
          </Grid>
        ) : null}
        {canViewFirmGoals ? (
          <Grid item xs={12} md={3}>
            <CardTile
              index={2}
              to='/admin/data-maintenance/firm-goals'
              icon={ICON_NAMES.edit}
              title='Manage Firm Goals'
            />
          </Grid>
        ) : null}
      </Grid>
    </Container>
  )
}

export default DataMaintenance
